import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCheck, FaTimes } from 'react-icons/fa';

/**
 * Toast notification component with New Relic styling
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether to show the toast
 * @param {string} props.message - Toast message text
 * @param {string} props.type - Toast type ('success' or 'error')
 * @param {function} props.onClose - Function to call when toast closes
 * @returns {JSX.Element} Toast notification
 */
function Toast({ show, message, type = 'success', onClose }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className={`toast toast-${type}`}
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.9 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          <div className="toast-content">
            <div className="toast-icon">
              {type === 'success' ? <FaCheck /> : <FaTimes />}
            </div>
            <span className="toast-message">{message}</span>
          </div>
          <button className="toast-close" onClick={onClose}>
            <FaTimes />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Toast;
